import { Svg } from 'components/svg'
import { IconType } from 'models'

export const IconTwitter: IconType = ({ className = '' }) => (
  <Svg className={className} viewBox="0 0 24 24">
    <path
      fill="currentColor"
      d="M16.78 9.56a7.21 7.21 0 0 1-1.91 5.16 6.76 6.76 0 0 1-4.93 2.16h-.33A6.74 6.74 0 0 1 6 15.78a4.88 4.88 0 0 0 3.55-1s.1 0 0-.06a2.42 2.42 0 0 1-2.26-1.7A2.34 2.34 0 0 0 8.43 13a2.45 2.45 0 0 1-2-2.44 2.5 2.5 0 0 0 1.09.3 2.48 2.48 0 0 0-.3-.25 2.49 2.49 0 0 1-.44-3 7 7 0 0 0 5.09 2.58A2.52 2.52 0 0 1 12.4 8a2.46 2.46 0 0 1 1.82-.91h.18a2.53 2.53 0 0 1 1.72.78 5.27 5.27 0 0 0 1.56-.59 2.58 2.58 0 0 1-1.08 1.39 5.73 5.73 0 0 0 1.4-.39 5.12 5.12 0 0 1-1.22 1.28z"
    />
  </Svg>
)
